export enum GatewayStatus {
    ACTIVE = 'ACTIVE',
    STOPPED = 'STOPPED',
    PAUSED = 'PAUSED',
    STARTING = 'STARTING',
    STOPPING = 'STOPPING',
    PAUSING = 'PAUSING'
}

export type Gateway = {
    id: number
    name: string
    status: GatewayStatus
}

export type GatewayUpdate = {
    id: number
    gateway_name: string
    status: GatewayStatus
}
